import { gql, TypedDocumentNode } from "@apollo/client";

import { WorkerUsage } from "types/generated";

type GetWorkerUsageData = {
  workerUsage: WorkerUsage;
};

type GetWorkerUsageVariables = {
  percentiles: number[];
};

export const GET_WORKER_USAGE: TypedDocumentNode<GetWorkerUsageData, GetWorkerUsageVariables> = gql`
  query GetWorkerUsage($percentiles: [Int!]!) {
    workerUsage {
      cycle {
        start
        end
      }
      daily(percentiles: $percentiles) {
        day
        max
        concurrencyAtContractedPercentileToDate
        concurrencyAtPercentilesToDate {
          percentile
          value
        }
        burstMinutesUsed
      }
      concurrencyPercentiles(percentiles: $percentiles) {
        percentile
        value
      }
      concurrencyAtContractedPercentile
      contractedLimit
      contractedPercentile
      burst {
        budgetMinutes
        usedMinutes
        remainingMinutes
      }
    }
  }
`;
